import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Colors } from '../../styles/colors';
import { Icon } from './Icon';
import { Button } from './Button';
import { PopupOverlay } from './PopupOverlay';
import { atom } from 'recoil';
import { useSetRecoilState } from 'recoil';
import { useRecoilValue } from 'recoil';

export interface ConfirmationPopupConfig {
  open: boolean;
  renderer: () => ReactNode;
  actionButtonLabel: string;
  closeFn: () => void;
  actionFn: (close: () => void) => void;
}

export interface ConfirmationPopupProps {
  config: ConfirmationPopupConfig | null;
}

export const ConfirmationPopupState = atom<ConfirmationPopupProps>({
  key: 'ConfirmationPopupState',
  default: {
    config: null,
  },
});

export const useShowConfirmationPopup: () => (config: ConfirmationPopupConfig | null) => void = () => {
  const setState = useSetRecoilState(ConfirmationPopupState);
  return (config: ConfirmationPopupConfig | null) => {
    setState({ config });
  }
}
export const useConfirmationPopup: () => ConfirmationPopupConfig | null = () => useRecoilValue(ConfirmationPopupState).config;


const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${Colors.background};
  padding: 6rem 9rem;
  position: relative;
`;

const CloseIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  color: ${Colors.gray};
  margin-bottom: 2.5rem;
  position: absolute;
  right: 3rem;
  top: 3rem;
  border: 1px solid ${Colors.gray};
  border-radius: 9rem;
  line-height: .75;
  padding: .5rem;

  i {
    font-size: 2px;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${Colors.gray};
  margin-bottom: 3rem;
`;

const ActionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ButtonWrapper = styled.div`
  cursor: pointer;
`;


export const ConfirmationPopup: FC<ConfirmationPopupProps> = (props) => {
  const { config } = props;
  
  return (
    <PopupOverlay {...{ open: config?.open }}>
      <Wrapper>
        <CloseIconWrapper>
          <ButtonWrapper
            onClick={() => {
                config?.closeFn();
            }}
          >
            <Icon icon={'close'} size={18} />
          </ButtonWrapper>
        </CloseIconWrapper>
        <ContentWrapper>
          {config?.renderer()}
        </ContentWrapper>
        <ActionWrapper>
          <ButtonWrapper>
            <Button
              type={'secondary'}
              onClick={() => {
                config?.closeFn();
              }}
            >Abbrechen</Button>
          </ButtonWrapper>
          <ButtonWrapper>
            <Button
              type={'primary'}
              onClick={() => {
                config?.actionFn(() => config?.closeFn());
              }}
            >{config?.actionButtonLabel}</Button>
          </ButtonWrapper>
        </ActionWrapper>
      </Wrapper>
    </PopupOverlay>
  );
};
